export default {
  boolean: { 1: '是', 0: '否' },
  boolean2: { 0: '是', 1: '否' },
  has: { 0: '无', 1: '有' },
  isHidden: { 0: '启用', 1: '禁用' },
  isDisable: { 0: '启用', 1: '禁用' },
  sex: { 0: '女', 1: '男' },
  subjectType: { 1: '自选', 2: '抽题' },
  screenStatus: { 0: '不限', 1: '竖屏', 2: '横屏' },
  status: { 0: '待填写', 1: '待发布', 2: '已发布', 3: '已关闭' },
  examStatus: { 0: '未开始', 1: '考生考试中', 2: '考试结束' },
  examStatus2: { 0: '未开始考试', 1: '未完成考试', 2: '考试中', 3: '已完成考试' },
  categoryLevel: { 1: '一级分类', 2: '二级专业', 3: '三级级别' },
  payStatus: { 0: '未支付', 1: '已支付', 2: '已退款' },
  isPayed: { 0: '待付款', 1: '已付款' },
  isImport: { 0: '线上', 1: '导入' },
  isSuccess: { 0: '退款失败', 1: '退款成功' },
  auditStatus: { 1: '审核中', 2: '审核通过', 3: '审核未通过', 4: '已取消' },
  settleAuditStatus: { 1: '待确认', 2: '已确认', 3: '已取消' },
  incomeStatus: { 0: '未结算', 1: '已结算' },
  questionType: { 1: '模拟', 2: '正式' },
  newsType: { 0: '图文' },
  newsModule: { 0: '协会动态', 1: '会员中心', 2: '赛事活动', 3: '考级咨询' },
  linkType: { 0: '文章', 1: '外链' },
  payType: { 1: '微信' },
  tradeState: { 0: '待支付', 1: '未支付', 2: '已支付', 3: '已取消', 4: '申请退款', 5: '已退款', 6: '退款失败' },
  idType: { '1': '身份证', '2': '港澳通行证', '3': '护照', '4': '台胞证' },
  smsType: { 0: '注册', 1: '找回密码', 2: '登录', 3: '修改账号' },
  countryCode: [{ code: '000000', desc: '国际' }, { code: '000001', desc: '中国大陆' }, { code: '999999', desc: '港澳台侨' }],
  evaluateStatus2: { 0: '未评分', 1: '评分中', 2: '已评分', 3: '已发布' },
  system: { 0: '体制内', 1: '新文艺群体', 2: '空' },
  vipPayStatus: { 0: '已交终身会费', 1: '未交', 2: '高龄免缴' },
  infoStatus: { 0: '未更新', 1: '已更新', 2: '临时保存', 3: '失联', 4: '不配合', 5: '电话有误', 6: '出国定居' },
  currentStatus: { 0: '在职', 1: '离职退休', 2: '出国定居', 3: '失联', 4: '重疾', 5: '去世', 6: '退会', 7: '开除', 8: '空' },
  degree: { 0: '博士研究生', 1: '硕士研究生', 2: '大学', 3: '大专', 4: '高中', '5': '无' },
  politicalStatus: { 0: '中共', 1: '民革', 2: '民盟', 3: '民建', 4: '民进', 5: '农工', 6: '致公', 7: '九三学社', 8: '台盟', 9: '无党派', 10: '群众', 11: '空' },
  vipIdType: { 1: '身份证', 2: '港澳通行证', 3: '护照', 4: '军官证' },
  specialZhicheng: { 0: '正高', 1: '副高', 2: '中级', 3: '初级', 4: '无' },
  vipAuditStatus: { 0: '未提交申请', 1: '待审核', 2: '初审通过', 3: '初审未通过', 4: '终审通过', 5: '终审不通过' },
  vipAuditStatus1: { 1: '待审核', 2: '初审通过', 3: '初审未通过', 4: '终审通过', 5: '终审不通过' },
  vipAuditStatus2: { 1: '待审核', 2: '初审通过', 3: '初审未通过' },
  systemInfo: { 0: '体制内', 1: '新文艺群体', 2: '空' },
  nationality: { 0: '中国', 1: '国外' },
  professional: { 0: '创作', 1: '理论', 2: '表演', 3: '其他' },
  education: { 0: '博士研究生', 1: '硕士研究生', 2: '大学', 3: '大专', 4: '高中', 5: '无' },
  authentication: { 0: '未认证', 1: '已认证' },
  financeIdType1: {
    // '52': '组织机构代码证',
    // '68': '营业执照',
    // '73': '统一社会信用代码',
    '1': '身份证',
    '3': '港澳台居民通行证(即回乡证)',
    '4': '中国护照',
    '5': '台湾居民来往大陆通行证(即台胞证)',
    '19': '外国护照'
  },
  financeIdType2: {
    '52': '组织机构代码证',
    '68': '营业执照',
    '73': '统一社会信用代码'
  },
  financeAuditStatus: {
    0: '待审核',
    1: '审核通过',
    2: '审核不通过'
  },
  // 报名状态
  signUpStatusType: {
    0: '未报名',
    1: '已报名'
  },
  // 提现状态
  cashStatus: {
    0: '开户中',
    1: '已开户',
    2: '"已绑卡',
    3: '已绑卡鉴权',
    4: '已提现'
  },
  mchType: {
    0: '个人商户',
    1: '个体工商户',
    2: '企业商户'
  },
  isNewest: { 0: '待发布', 1: '待确认', 2: '已确认', 3: '已取消' },
  isSettle: { 0: '未结算', 1: '已结算' },
  settlementStatus: { 0: '制单完成', 1: '结算中', 2: '结算中', 3: '结算中', 4: '结算中', 5: '结算成功', 6: '账单已撤销', 7: '结算中', 8: '结算中', 9: '结算中' },
  confirmStatus: { 0: '待机构确认', 1: '机构已确认', 2: '机构已打回' },
  serviceType: {
    1: '基础功能',
    2: '录播考试功能',
    3: '直播监考（主机）',
    4: '直播监考（辅机）',
    5: '互动直播面试',
    6: '智能评分功能（在线）',
    7: '智能评分功能（局域网）',
    8: '短信服务费',
    9: '驻场服务-现场技术支持',
    10: '广告费',
    11: '留学提成',
    12: '退款垫资',
    13: '其他',
    14: '手续费'
  },
  settleStatus: {
    1: '结算中',
    2: '已结算',
    3: '已取消'
  },
  recordExamStatus: { 1: '考试未开始', 2: '考试未参加', 3: '考试中', 4: '考试未完成', 5: '考试已完成' },
  needExpress: { 0: '不需要邮寄', 1: '需要邮寄' },
  refundType: { 0: '报名费', 1: '证书快递费' },
  refundAuditStatus: { 1: '待审核', 2: '审核通过并退费', 3: '审核不通过' }
}
